/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RouteLocationItemOutput
 */
export interface RouteLocationItemOutput {
    /**
     * 
     * @type {string}
     * @memberof RouteLocationItemOutput
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RouteLocationItemOutput
     */
    label?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RouteLocationItemOutput
     */
    effective?: boolean;
}

export function RouteLocationItemOutputFromJSON(json: any): RouteLocationItemOutput {
    return RouteLocationItemOutputFromJSONTyped(json, false);
}

export function RouteLocationItemOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): RouteLocationItemOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'effective': !exists(json, 'effective') ? undefined : json['effective'],
    };
}

export function RouteLocationItemOutputToJSON(value?: RouteLocationItemOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'label': value.label,
        'effective': value.effective,
    };
}


